<template>
	<Status>
		<template #header>
			<Header />
		</template>
	</Status>
</template>

<script setup lang="ts">
import Header from "@/rmo/components/Header.vue";
import Status from "@/rmo/content/Status.vue";
</script>
